import React from "react";
import { Link } from "react-router-dom";
import "./whyvits.css";
import { useEffect, useRef } from 'react';
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(ScrollTrigger);


function Whyvits() {
  const ref = useRef();
    useEffect(() => {
        const el = ref.current;
        gsap.fromTo(el, {x:-250 ,opacity:0}, 
          {
            x:.1, duration: 1.4,delay:.6,opacity:1, scrollTrigger: {
                trigger: el,
            }
        })
    }, [])
  return (
    <div className="whyvits_container" ref={ref}>
      <br />
      <center>
        <h2 style={{ fontSize: "34px" }}>Let's <span  style={{ color: "rgb(119,94,209)"}}>Explore</span></h2>
      </center>
      <div className="whyvits_sub">
        <div className="left_container">
          <h1>
            Why choose <span style={{ color: "rgb(9,94,129)" }}>VITS</span>
          </h1>
          <br />
          <p>
            "Studying at VITS campus offers you the opportunity to undertake a
            cutting edge degree that will excite you and help you realise your
            career aspirations. These are some of the high-lights as to why
            should you choose us."We at Vindhya Group of Institutions has a
            systematic process of meeting students career aspirations and
            corporate expectations.The Department acts a bridge between the
            institution and students.Our training modules are well designed to
            meet the emerging needs of the corporates.We are blessed with
            excellent alumni record and our students are representing us in top
            corporates globally.
          </p>
          <br />
          <button className="left_container_btn">
            <Link>
              Know more&nbsp;<i className="fa fa-fire"></i>
            </Link>
          </button>
        </div>
        <div className="right_container">
          <img
            src="https://media.istockphoto.com/id/1400839985/vector/recruiting-hr-and-employee-review-team-building-vector.jpg?s=612x612&w=0&k=20&c=ZXVuuCvAI3Lwk_CrZkixjtPZzjra48aHi_MwaQd5NEQ="
            alt=""
          />
        </div>
      </div>
    </div>
  );
}

export default Whyvits;
